import { BrowserRouter } from 'react-router-dom'
import './App.scss'
import './styles/layout/layout.scss'

// PrimeReact styles
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.min.css'
import 'primereact/resources/themes/soho-dark/theme.css'

// Import providers
import AppLayout from 'layout/components/app-layout'
import AppRoutes from 'layout/components/app-routes'
import { AuthProvider } from 'layout/context/auth-context'
import { LayoutProvider } from 'layout/context/layout-context'
import { HealthCheckProvider } from 'layout/context/healthCheckContext'
import { SignalRProvider } from 'layout/context/signalr-context'
import AlarmDialog from 'layout/components/alarm-dialog'
import { LoadingProvider } from './layout/context/loading-context'
import { ToastProvider } from './layout/context/toast-context'

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <LoadingProvider>
          <LayoutProvider>
            <AuthProvider>
              <HealthCheckProvider>
                {/* Alarms must reach the user on any screen, so the hub
                    connection lives at the root instead of per-route. */}
                <SignalRProvider>
                  <AlarmDialog />
                  <div className='App'>
                    <AppLayout>
                      <AppRoutes />
                    </AppLayout>
                  </div>
                </SignalRProvider>
              </HealthCheckProvider>
            </AuthProvider>
          </LayoutProvider>
        </LoadingProvider>
      </ToastProvider>
    </BrowserRouter>
  )
}

export default App
